import classnames from 'classnames';
import { Link } from 'react-router-dom';

import styles from './BlockedEhrBanner.module.scss';
import { translate } from '@chaika/i18n/helper';

interface Props {
    url?: string;
    onEhrPage?: boolean;
}

export function BlockedEhrBanner({ url, onEhrPage = false }: Props) {
    const tPatientHasDebt = translate('patientHasDebt');
    const tShowDetail = translate('showDetails');
    return (
        <div className={classnames([styles.root, onEhrPage && styles.ehrPage, !onEhrPage && styles.withBorderRadius])}>
            {onEhrPage ? (
                tPatientHasDebt
            ) : (
                <>
                    {tPatientHasDebt}
                    <br />
                </>
            )}
            {url && (
                <Link
                    className={styles.link}
                    to={url}
                    target={onEhrPage ? '_self' : '_blank'}
                >
                    {tShowDetail}
                </Link>
            )}
        </div>
    );
}
